import { Ic } from '../shared/Icons';
import { mobileTabSurfaces, activeNavId } from '../../lib/surfaces';
import { useNeedsYouCount } from '../../hooks/useNeedsYouCount';

// Mobile primary navigation. The tab SET comes from lib/surfaces — the one registry the desktop
// pills and the command palette also read — so a surface can no longer exist on one nav control
// and be missing from the others. Sources/Settings/Sign-out stay in the TopNav avatar menu.
//
// Actions earns a tab because it carries the app's only unread badge: the desktop pill row is
// unmounted below 640px, so the "needs you" count previously had nowhere to render on a phone.
// Ask earns one because the map force-renders List on mobile (no touch canvas), so Knowledge is
// degraded on a phone while Ask is fully native.
const ICONS: Record<string, JSX.Element> = {
  briefing: <Ic.Pulse />,
  actions: <Ic.Alert />,
  ask: <Ic.Ask />,
  map: <Ic.Map />,
  people: <Ic.Identity />,
};

export function BottomTabBar({ route, onNav }: { route: string; onNav: (id: string) => void }) {
  // A child route lights its parent's tab (a note reads as Knowledge, not as nothing).
  const activeId = activeNavId(route);
  const needsYou = useNeedsYouCount();

  return (
    <nav className="mobile-tabbar" role="navigation" aria-label="Primary">
      {mobileTabSurfaces().map((t) => (
        <button
          key={t.id}
          className={`mtab${activeId === t.id ? ' active' : ''}`}
          onClick={() => onNav(t.id)}
          aria-current={activeId === t.id ? 'page' : undefined}
        >
          <span className="mtab-ic" aria-hidden="true">
            {ICONS[t.id]}
            {t.id === 'actions' && needsYou > 0 && <span className="mtab-badge">{needsYou}</span>}
          </span>
          <span className="mtab-label">{t.label}</span>
        </button>
      ))}
    </nav>
  );
}
